export const WEBSITES = 'WEBSITES'
export const WEBSITES_STATUS = 'WEBSITES_STATUS'
export const DELETE_WEBSITE_STATUS = 'DELETE_WEBSITE_STATUS'
export const DELETE_WEBSITE = 'DELETE_WEBSITE'
export const PROJECT_WEBSITES = 'PROJECT_WEBSITES'
export const PROJECT_WEBSITES_STATUS = 'PROJECT_WEBSITES_STATUS'
export const WEBSITE_UPDATE_STATUS = 'WEBSITE_UPDATE_STATUS'
export const WEBSITE_UPDATE = 'WEBSITE_UPDATE'
